import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import _ from 'lodash';
import { DashboardService } from 'projects/shared-lib/src/lib/services/dashboard.service';
import { DataService } from 'projects/shared-lib/src/lib/services/data.service';
import { Global } from 'projects/shared-lib/src/lib/_constants/global.variables';
import { IGlobal } from '../../_models/global.model';

@Component({
	selector: 'lib-dashboard-timescope-popup-confirmation-settings',
	templateUrl:
		'./dashboard-timescope-popup-confirmation-settings.component.html',
	styleUrls: [
		'./dashboard-timescope-popup-confirmation-settings.component.scss',
	],
})
export class DashboardTimescopePopupConfirmationSettingsComponent
	implements OnInit
{
	public global: IGlobal = Global;

	constructor(
		@Inject(MAT_DIALOG_DATA) public inputObject: any,
		public dialogRef: MatDialogRef<DashboardTimescopePopupConfirmationSettingsComponent>,
		private dataService: DataService,
		public toastr: ToastrService,
		private dashboardService: DashboardService
	) {}

	ngOnInit() {
		this.inputObject.dashboardWidgets.forEach((widget) => {
			let currentlyAssignedTimeScope = this.inputObject.timeScopes.find(
				(ts) => ts.Id === widget.TimeScopeId
			);
			if (!_.isNil(currentlyAssignedTimeScope)) {
				widget.TimeScopeDescription =
					currentlyAssignedTimeScope.Description;
				if (
					currentlyAssignedTimeScope.Id ===
					this.inputObject.selectedTimescopeObject.Id
				) {
					widget.isTimeScopeSelected = true;
				} else {
					widget.isTimeScopeSelected = false;
				}
			} else {
				widget.isTimeScopeSelected = true;
				widget.TimeScopeDescription = '';
			}
		});
		console.log(this.inputObject);
	}

	onCancel() {
		this.dialogRef.close();
	}

	submitAndClose() {
		this.dialogRef.close(this.inputObject);
	}

	selectAllAndClose() {
		this.inputObject.dashboardWidgets.forEach((widget) => {
			widget.isTimeScopeSelected = true;
		});
		this.submitAndClose();
	}
}
